import { PURCHASE_ORDER_RECEIPTS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/purchase_order_receipts_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['purchaseOrderReceiptsIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
